import type { ComponentPropsWithRef } from 'react';
import type React from 'react';

import { useMergeRefs } from '@floating-ui/react';

import { FocusRing } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { useTooltipContext } from '../hooks/context';

export const TooltipTrigger = (({ children, ref: propRef, className, ...props }) => {
	const context = useTooltipContext();
	const ref = useMergeRefs([context.refs.setReference, propRef]);

	return (
		<FocusRing focusRingClass="rounded-sm">
			<button
				type="button"
				ref={ref}
				// Before the prop spread so a caller can still opt out. Safari skips a native <button> on
				// Tab without an explicit tabindex.
				tabIndex={0} // see accessibility.md
				className={cn('text-icon-strong m-0 cursor-pointer border-0 bg-transparent p-0 leading-[0]', className)}
				{...context.getReferenceProps(props)}
			>
				{children}
			</button>
		</FocusRing>
	);
}) as React.FC<ComponentPropsWithRef<'button'>>;
